document.addEventListener("DOMContentLoaded", function () {
  const slider = document.getElementById("how-it-works-slider");
  const videoItems = document.querySelectorAll(".how-video-item");
  const isMobile = window.matchMedia("(max-width: 768px)").matches;

  // Lazy load and initialize videos
  function lazyLoadVideo(videoItem) {
    if (videoItem.getAttribute("data-video-loaded") === "true") return;

    const video = videoItem.querySelector(".how-it-works-video");
    const posterImg = videoItem.querySelector(".how-it-works-poster");
    const loader = videoItem.querySelector(".video-loader");

    if (!video || !video.hasAttribute("data-src")) return;

    // Set video source and attributes
    videoItem.setAttribute("data-video-status", "loading");

    // Show loader
    if (loader) {
      loader.style.display = "flex";
    }

    // Get the video source URL
    const videoSrc = video.getAttribute("data-src");
    video.src = videoSrc;
    video.poster = video.getAttribute("data-poster") || "";
    video.load(); // Force the video to start loading

    // Track if loader has been hidden to prevent multiple calls
    let loaderHidden = false;
    let timeoutId;

    // Function to hide loader and show video (only call once)
    const hideLoaderAndShowVideo = () => {
      if (loaderHidden) return;
      loaderHidden = true;

      if (timeoutId) clearTimeout(timeoutId);
      videoItem.setAttribute("data-video-status", "loaded");

      if (loader) {
        loader.style.display = "none";
      }
      if (posterImg) {
        posterImg.style.transition = "opacity 0.5s ease";
        posterImg.style.opacity = "0";
        setTimeout(() => {
          posterImg.style.display = "none";
        }, 500);
      }
      video.classList.add("quality-loaded");
    };

    // Handle video load errors
    const onError = () => {
      if (loaderHidden) return;
      loaderHidden = true;

      if (timeoutId) clearTimeout(timeoutId);
      videoItem.setAttribute("data-video-status", "error");
      if (loader) {
        loader.style.display = "none";
      }
      console.error("Failed to load video:", videoSrc);
    };

    // Add timeout fallback to hide loader if video takes too long
    timeoutId = setTimeout(() => {
      console.warn("Video loading timeout for:", videoSrc);
      hideLoaderAndShowVideo();
    }, 10000); // 10 second timeout

    // Listen for multiple events to ensure we catch when video is ready
    video.addEventListener("canplay", hideLoaderAndShowVideo, { once: true });
    video.addEventListener("loadeddata", hideLoaderAndShowVideo, {
      once: true,
    });
    video.addEventListener("loadedmetadata", hideLoaderAndShowVideo, {
      once: true,
    });
    video.addEventListener("error", onError, { once: true });

    videoItem.setAttribute("data-video-loaded", "true");
  }

  // Intersection Observer for lazy loading videos (only on mobile)
  if (isMobile) {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          const videoItem = entry.target.closest(".how-video-item");
          if (entry.isIntersecting) {
            // Lazy load the video source on mobile when it comes into view
            lazyLoadVideo(videoItem);
          }
        });
      },
      {
        threshold: 0.1,
        rootMargin: "50px",
      }
    );

    // Observe all video items on mobile
    videoItems.forEach((videoItem) => {
      observer.observe(videoItem);
    });
  }

  // Video playback control
  function setupVideoPlayback() {
    const videos = document.querySelectorAll(".how-it-works-video");

    videos.forEach((video) => {
      const videoItem = video.closest(".how-video-item");
      const container = videoItem;

      if (isMobile) {
        // Mobile: Play when in viewport (videos already lazy loaded when entering viewport)
        const videoObserver = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) {
                if (
                  !video.hasAttribute("data-user-paused") &&
                  video.readyState >= 2
                ) {
                  video
                    .play()
                    .catch((e) => console.log("Autoplay prevented:", e));
                }
              } else {
                video.pause();
              }
            });
          },
          {
            threshold: 0.5,
            rootMargin: "0px 0px 50px 0px",
          }
        );

        videoObserver.observe(video);

        // User interaction controls
        container.addEventListener("touchstart", () => {
          video.setAttribute("data-user-paused", "true");
          video.pause();
        });

        container.addEventListener("touchend", () => {
          setTimeout(() => {
            if (isElementInViewport(video)) {
              video.removeAttribute("data-user-paused");
              video.play().catch((e) => console.log("Resume prevented:", e));
            }
          }, 300);
        });
      } else {
        // Desktop: Load and play on hover
        container.addEventListener("mouseenter", () => {
          lazyLoadVideo(videoItem);
          // Wait a bit for video to start loading, then play
          setTimeout(() => {
            if (video.readyState >= 2) {
              video.play().catch((e) => console.log("Play prevented:", e));
            } else {
              video.addEventListener(
                "loadeddata",
                () => {
                  video.play().catch((e) => console.log("Play prevented:", e));
                },
                { once: true }
              );
            }
          }, 100);
        });

        container.addEventListener("mouseleave", () => video.pause());
      }
    });
  }

  setupVideoPlayback();

  function isElementInViewport(el) {
    const rect = el.getBoundingClientRect();
    return (
      rect.top >= 0 &&
      rect.left >= 0 &&
      rect.bottom <=
        (window.innerHeight || document.documentElement.clientHeight) * 1.5 &&
      rect.right <= (window.innerWidth || document.documentElement.clientWidth)
    );
  }

  function initHowItWorksSlider() {
    const slider = document.getElementById("how-it-works-slider");
    if (!slider) return;

    const container = slider.parentElement;
    let isSmall = window.innerWidth < 768;
    let currentGap = isSmall ? 10 : 16;

    const items = slider.querySelectorAll(".how-video-item");
    const adjustCardsWidth = () => {
      isSmall = window.innerWidth < 768;
      currentGap = isSmall ? 10 : 16;
      const containerWidth = container.offsetWidth;
      items.forEach((item) => {
        item.style.width = isSmall
          ? `${containerWidth / 2 - currentGap * 3}px`
          : `${containerWidth / 4 - currentGap * 3}px`;
      });
    };

    adjustCardsWidth();

    if (!items.length) return;

    const getCardWidth = () => items[0].offsetWidth + currentGap;
    const cardWidth = getCardWidth();

    let currentPosition = 0;
    let maxPosition =
      Math.ceil((slider.scrollWidth - container.offsetWidth) / cardWidth) *
      cardWidth;

    let isDragging = false;
    let startX = 0;
    let startPosition = 0;
    const clickThreshold = 5;

    slider.querySelectorAll("img").forEach((img) => {
      img.setAttribute("draggable", "false");
      img.addEventListener("dragstart", (e) => {
        e.preventDefault();
        return false;
      });
    });

    slider.addEventListener("mousedown", startDrag);
    slider.addEventListener("touchstart", startDrag, { passive: false });

    function startDrag(e) {
      if (e.type === "mousedown" && e.button !== 0) return;

      isDragging = false;
      startX = e.type === "touchstart" ? e.touches[0].clientX : e.clientX;
      startPosition = currentPosition;

      document.addEventListener("mousemove", handleDrag);
      document.addEventListener("touchmove", handleDrag, { passive: false });
      document.addEventListener("mouseup", endDrag);
      document.addEventListener("touchend", endDrag);

      e.preventDefault();
    }

    function handleDrag(e) {
      const currentX =
        e.type === "touchmove" ? e.touches[0].clientX : e.clientX;
      const diff = startX - currentX;

      if (!isDragging && Math.abs(diff) < clickThreshold) return;

      if (!isDragging) {
        isDragging = true;
        slider.classList.add("dragging");
        document.body.classList.add("slider-dragging");
        slider.style.transition = "none";
      }

      currentPosition = Math.max(
        Math.min(startPosition - diff, 0),
        -maxPosition
      );
      slider.style.transform = `translateX(${currentPosition}px)`;

      e.preventDefault();
    }

    function endDrag(e) {
      document.removeEventListener("mousemove", handleDrag);
      document.removeEventListener("touchmove", handleDrag);
      document.removeEventListener("mouseup", endDrag);
      document.removeEventListener("touchend", endDrag);

      document.body.classList.remove("slider-dragging");

      if (!isDragging) {
        const target = e.target.closest("a");
        if (target) target.click();
        return;
      }

      isDragging = false;
      slider.classList.remove("dragging");

      const cardIndex = Math.round(Math.abs(currentPosition) / cardWidth);
      currentPosition = -Math.min(cardIndex * cardWidth, maxPosition);

      slideTo(currentPosition);
    }

    function slideTo(position) {
      currentPosition = position;
      slider.style.transition = "transform 0.3s ease";
      slider.style.transform = `translateX(${position}px)`;
    }

    window.addEventListener(
      "resize",
      debounce(() => {
        maxPosition =
          Math.ceil((slider.scrollWidth - container.offsetWidth) / cardWidth) *
          cardWidth;
        currentPosition = Math.max(Math.min(currentPosition, 0), -maxPosition);
        adjustCardsWidth();
        slideTo(currentPosition);
      }, 16)
    );
  }

  initHowItWorksSlider();

  //   INSTRUCTIONS
  // Handle quick add buttons
  document.querySelectorAll(".static-quick-add-btn").forEach((button) => {
    button.addEventListener("click", async function (e) {
      e.preventDefault();
      const variantId = this.dataset.variantId;
      const form = document.getElementById(`static-quick-add-${variantId}`);

      if (!form) return;

      // Add loading state
      this.classList.add("loading");

      try {
        // Submit the form
        const response = await fetch(routes.cart_add_url + ".js", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            items: [
              {
                id: variantId,
                quantity: 1,
              },
            ],
          }),
        });

        const data = await response.json();

        if (response.ok) {
          // Trigger cart update event if available
          if (PUB_SUB_EVENTS) {
            publish(PUB_SUB_EVENTS.cartUpdate, {
              action: "add",
              variant: data,
              source: "product-instructions",
            });
          }

          // Add success animation
          this.classList.remove("loading");
          this.classList.add("success");
          setTimeout(() => this.classList.remove("success"), 1000);
        } else {
          throw new Error(data.description || "Failed to add to cart");
        }
      } catch (error) {
        console.error("Error:", error);

        // Reset button state
        this.classList.remove("loading");
      }
    });
  });

  const section = document.querySelector(".show-section");

  const sliderShow = section.querySelector(".show-slider");
  const container = section.querySelector(".show-container");
  const cards = sliderShow.querySelectorAll(".show-card:not(.clone)");
  if (!cards.length) return;

  // --- Mark originals
  cards.forEach((card) => card.classList.add("original"));

  // Batch all DOM reads to avoid forced reflows
  let cardWidth, originalContentWidth, containerWidth;

  function updateDimensions() {
    const gap = parseInt(window.getComputedStyle(sliderShow).gap) || 15;
    cardWidth = cards[0].offsetWidth + gap;
    originalContentWidth = cardWidth * cards.length;
    containerWidth = container.offsetWidth;
  }

  // Initial dimension calculation
  updateDimensions();

  // --- Only enable auto scroll if content wider than container
  if (originalContentWidth <= containerWidth - cardWidth) {
    sliderShow.style.justifyContent = "center";
    return;
  }

  // === Create clones for seamless infinite scroll
  function createClones() {
    sliderShow
      .querySelectorAll(".show-card.clone")
      .forEach((clone) => clone.remove());

    const viewportCardCount = Math.ceil(containerWidth / cardWidth) + 2;

    for (let i = 0; i < viewportCardCount; i++) {
      if (cards[i]) {
        const rightClone = cards[i].cloneNode(true);
        rightClone.classList.add("clone", "right");
        sliderShow.appendChild(rightClone);
      }
      if (cards[cards.length - 1 - i]) {
        const leftClone = cards[cards.length - 1 - i].cloneNode(true);
        leftClone.classList.add("clone", "left");
        sliderShow.prepend(leftClone);
      }
    }
  }

  createClones();

  // === Slider state
  let isDragging = false;
  let startPos = 0;
  let currentTranslate = -originalContentWidth; // start centered
  let prevTranslate = currentTranslate;
  let animationID;
  const autoScrollSpeed = 0.5;
  let isAutoScrolling = true;

  sliderShow.style.transform = `translateX(${currentTranslate}px)`;

  // --- Helpers
  function getPositionX(e) {
    return e.type.includes("mouse") ? e.pageX : e.touches[0].clientX;
  }

  // --- Drag / Touch
  function startDrag(e) {
    isDragging = true;
    startPos = getPositionX(e);
    cancelAnimationFrame(animationID);
    isAutoScrolling = false;
    sliderShow.style.cursor = "grabbing";
    sliderShow.classList.add("no-transition");
  }

  function handleDrag(e) {
    const currentPos = getPositionX(e);
    currentTranslate = prevTranslate + currentPos - startPos;
    sliderShow.style.transform = `translate3d(${currentTranslate}px,0,0)`;
  }

  function endDrag() {
    if (!isDragging) return;
    isDragging = false;
    sliderShow.style.cursor = "grab";
    sliderShow.classList.remove("no-transition");
    checkForReset();
    startAutoScroll();
  }

  // --- Event bindings
  sliderShow.addEventListener("mousedown", (e) => {
    if (e.button === 0) startDrag(e);
  });
  sliderShow.addEventListener("mousemove", (e) => {
    if (isDragging) handleDrag(e);
  });
  sliderShow.addEventListener("mouseup", endDrag);
  sliderShow.addEventListener("mouseleave", endDrag);

  sliderShow.addEventListener("touchstart", startDrag, { passive: false });
  sliderShow.addEventListener(
    "touchmove",
    (e) => {
      if (isDragging) handleDrag(e);
    },
    { passive: false }
  );
  sliderShow.addEventListener("touchend", endDrag);

  // === Infinite reset
  function checkForReset() {
    const leftBoundary = -originalContentWidth * 1.5;
    const rightBoundary = -originalContentWidth * 0.5;

    if (currentTranslate >= rightBoundary) {
      currentTranslate -= originalContentWidth;
    } else if (currentTranslate <= leftBoundary) {
      currentTranslate += originalContentWidth;
    }
    prevTranslate = currentTranslate;
    sliderShow.style.transform = `translate3d(${currentTranslate}px,0,0)`;
  }

  // === Auto scroll
  function startAutoScroll() {
    isAutoScrolling = true;
    let last = performance.now();
    const step = (now) => {
      if (!isAutoScrolling) return;
      const dt = now - last;
      last = now;
      if (!isDragging) {
        currentTranslate += autoScrollSpeed * (dt / 16); // normalise to ~60fps
        prevTranslate = currentTranslate;
        sliderShow.style.transform = `translate3d(${currentTranslate}px,0,0)`;
        checkForReset();
      }
      animationID = requestAnimationFrame(step);
    };
    animationID = requestAnimationFrame(step);
  }

  startAutoScroll();
});

// Stock Countdown Timer
document.addEventListener("DOMContentLoaded", function () {
  const stockCountdowns = document.querySelectorAll(".stock-countdown");

  stockCountdowns.forEach((countdownEl) => {
    const startDateStr = countdownEl.getAttribute("data-start-date");
    const endDateStr = countdownEl.getAttribute("data-end-date");
    const startingPercentage = parseInt(
      countdownEl.getAttribute("data-starting-percentage")
    );

    // Validate inputs
    if (!startDateStr || !endDateStr || !startingPercentage) {
      countdownEl.style.display = "none";
      return;
    }

    // Parse dates
    const startDate = new Date(startDateStr);
    const endDate = new Date(endDateStr);
    const now = new Date();

    // Validate date format and logic
    if (isNaN(startDate.getTime()) || isNaN(endDate.getTime())) {
      console.error("Invalid date format");
      countdownEl.style.display = "none";
      return;
    }

    // Check if end date is after start date
    if (endDate <= startDate) {
      console.error("End date must be after start date");
      countdownEl.style.display = "none";
      return;
    }

    // Get DOM elements
    const progressBar = countdownEl.querySelector(".stock-progress");
    const percentageText = countdownEl.querySelector("[data-percentage-text]");

    if (!progressBar || !percentageText) return;

    function calculateCurrentPercentage() {
      const now = new Date();

      // If before start time, hide the element (return -1 to indicate hide)
      if (now < startDate) {
        return -1;
      }

      // If after end time, hide the element
      if (now >= endDate) {
        return 0;
      }

      // Calculate time difference
      const totalDuration = endDate - startDate; // in milliseconds
      const elapsedTime = now - startDate; // in milliseconds

      // Calculate how many seconds per 1% decrease
      // Example: 12 minutes (720s) / 60% = 12 seconds per 1%
      const totalSeconds = totalDuration / 1000;
      const secondsPerPercentage = totalSeconds / startingPercentage;

      // Calculate how many percentage points have decreased
      const elapsedSeconds = elapsedTime / 1000;
      const percentagesDecreased = Math.floor(
        elapsedSeconds / secondsPerPercentage
      );

      // Calculate current percentage
      let currentPercentage = startingPercentage - percentagesDecreased;

      // Ensure percentage doesn't go below 0
      currentPercentage = Math.max(0, currentPercentage);

      return currentPercentage;
    }

    function updateCountdown() {
      const now = new Date();
      const currentPercentage = calculateCurrentPercentage();

      // Handle before start time - hide and schedule check for start time
      if (currentPercentage === -1) {
        countdownEl.style.display = "none";
        const timeUntilStart = startDate - now;
        if (timeUntilStart > 0) {
          setTimeout(updateCountdown, Math.max(100, timeUntilStart));
        }
        return;
      }

      // Hide if after end time or percentage reached 0
      if (currentPercentage <= 0) {
        countdownEl.style.display = "none";
        return;
      }

      // Show the element if it was hidden (e.g., when start time is reached)
      if (countdownEl.style.display === "none") {
        countdownEl.style.display = "";
        countdownEl.classList.remove("stock-countdown-hidden");
      }

      // Get current displayed percentage for animation
      const currentDisplayed = parseInt(
        progressBar.getAttribute("data-progress-width") || startingPercentage
      );

      // Only update if percentage changed
      if (currentPercentage !== currentDisplayed) {
        // Animate the progress bar width
        progressBar.style.transition = "width 0.5s ease-out";
        progressBar.style.width = `${currentPercentage}%`;
        progressBar.setAttribute("data-progress-width", currentPercentage);

        // Animate the percentage text
        percentageText.textContent = `${currentPercentage}% of the stock remaining`;
      }

      // Calculate time until next update based on what will happen first
      const timeUntilNextPercentage = calculateTimeUntilNextUpdate(now);

      // Schedule next update
      setTimeout(updateCountdown, timeUntilNextPercentage);
    }

    function calculateTimeUntilNextUpdate(now) {
      // If before start time, calculate when it should start
      if (now < startDate) {
        return Math.max(1000, startDate - now);
      }

      // If after end time, no update needed
      if (now >= endDate) {
        return 60000; // fallback
      }

      // Calculate when the next percentage decrease should happen
      const totalDuration = endDate - startDate;
      const elapsedTime = now - startDate;

      // Calculate seconds per 1% decrease (same as in calculateCurrentPercentage)
      const totalSeconds = totalDuration / 1000;
      const secondsPerPercentage = totalSeconds / startingPercentage;
      const msPerPercentage = secondsPerPercentage * 1000;

      // Calculate elapsed time in terms of percentage intervals
      const elapsedSeconds = elapsedTime / 1000;
      const completedIntervals = Math.floor(
        elapsedSeconds / secondsPerPercentage
      );
      const nextInterval = completedIntervals + 1;

      // Find when the next percentage decrease will happen
      const timeOfNextDecrease = nextInterval * msPerPercentage;
      const msUntilNextPercentage = timeOfNextDecrease - elapsedTime;

      // Also check when the countdown will reach 0
      const currentPercentage = calculateCurrentPercentage();
      const msUntilZero = currentPercentage * msPerPercentage;

      // Return the minimum of: next percentage decrease, reaching zero, or end time
      const timeUntilEnd = endDate - now;

      const minTime = Math.min(
        msUntilNextPercentage,
        msUntilZero,
        timeUntilEnd,
        60000
      );

      // Ensure minimum of 100ms to avoid zero/negative values
      return Math.max(100, minTime);
    }

    // Initial calculation and display
    const initialPercentage = calculateCurrentPercentage();

    // Handle before start time - hide and schedule check for start time
    if (initialPercentage === -1) {
      countdownEl.style.display = "none";
      const timeUntilStart = startDate - now;
      if (timeUntilStart > 0) {
        setTimeout(updateCountdown, Math.max(100, timeUntilStart));
      }
      return;
    }

    // Hide if after end time or percentage reached 0
    if (initialPercentage <= 0) {
      countdownEl.style.display = "none";
      return;
    }

    // Set initial state
    if (initialPercentage !== startingPercentage) {
      progressBar.style.width = `${initialPercentage}%`;
      progressBar.setAttribute("data-progress-width", initialPercentage);
      percentageText.textContent = `${initialPercentage}% of the stock remaining`;
    }

    // Show the element after calculating and updating the current percentage
    countdownEl.style.display = "";
    countdownEl.classList.remove("stock-countdown-hidden");

    // Start the countdown
    updateCountdown();
  });
});
